<script>
  // A labeled date filter, sized like the other filter controls (never the full-width
  // form DateField, which blows out a filter row). `nav` adds prev/next-day arrows
  // (enabled once a date is picked); the page supplies `onshift(±1)`.
  //   <FilterDate label="Start Date" value={startDate} onchange={(v) => (startDate = v)} />
  //   <FilterDate nav value={filters.date} onchange={…} onshift={(days) => …} />
  import FilterField from './filter_field.svelte'
  import Button from './ui/button.svelte'
  let { label = 'Date', id = undefined, value = '', onchange = null, nav = false, onshift = null } = $props()
</script>

<FilterField {label} for={id}>
  {#if nav}
    <div class="join">
      <Button variant="default" size="sm" class="join-item" disabled={!value} onclick={() => onshift?.(-1)} aria-label="Previous day">«</Button>
      <input {id} type="date" class="input input-sm join-item w-40" {value} onchange={(e) => onchange?.(e.currentTarget.value)} />
      <Button variant="default" size="sm" class="join-item" disabled={!value} onclick={() => onshift?.(1)} aria-label="Next day">»</Button>
    </div>
  {:else}
    <input {id} type="date" class="input input-sm w-40" {value} onchange={(e) => onchange?.(e.currentTarget.value)} />
  {/if}
</FilterField>
